import { render } from "./SaveTerminationReason.vue?vue&type=template&id=449d69d5"
import script from "./SaveTerminationReason.vue?vue&type=script&lang=js"
export * from "./SaveTerminationReason.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Azize HRM\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__